import * as React from 'react';

import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { QueryFilter, QUERY_FILTER_PUBLISHER } from 'src/component/shared';

import { TableCell, TableRow, IconButton, LinearProgress } from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

import './PublisherWeeklyEvolution.scss';
import { NumberLessBRL } from 'src/services';

// tslint:disable-next-line:no-empty-interface
interface IPublisherWeeklyEvolutionRowProps {
    row: any,
    weeks: number[]
}

// tslint:disable-next-line:no-empty-interface
interface IPublisherWeeklyEvolutionRowState {
    customFilter: {
        isChart: boolean
    },
    open: boolean

}

const PUBLISHER_WEEKLY_EVOLUTION_BOOKSTORES = gql`
query publisherWeeklyEvolutionBookstore($customFilter:  PublisherCustomFilter) {
    publisherWeeklyEvolutionBookstore(publisherCustomFilter: $customFilter) {
        code,
		name,
        data {
            code,
            name,
            billing,
            billingEvolution,
            volume,
            volumeEvolution
        }
    }
}
`;

export class PublisherWeeklyEvolutionRow extends React.Component<IPublisherWeeklyEvolutionRowProps, IPublisherWeeklyEvolutionRowState> {
    constructor(props: IPublisherWeeklyEvolutionRowProps) {
        super(props);
        this.state = {
            customFilter: {
                isChart: true,
            },
            open: false,
        }
        this.handleDetailOpen = this.handleDetailOpen.bind(this);
    }

    public render() {
        const jsonFilter = {
            "customFilter": {
                "isChart": this.state.customFilter.isChart,
            }
        };

        return (
            <React.Fragment>
                <TableRow key={'group'+this.props.row.code}>
                    <TableCell>
                        <IconButton aria-label="expand row" onClick={this.handleDetailOpen}>
                        {this.state.open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                    </TableCell>
                    <TableCell component="th" scope="row">{ this.props.row.name }</TableCell>
                    {
                        this.props.weeks.map((week: number) => {
                            return this.rendColumnsValuesForWeek (this.props.row, week)
                        })
                    }
                </TableRow>
                {this.state.open ? 
                    <Query query={QUERY_FILTER_PUBLISHER} notifyOnNetworkStatusChange={true}  >
                        {({ loading: loadingC, error: errorC, data: cache, client: clientC}) => {

                            const filter = QueryFilter.getFilterPublisher(clientC, jsonFilter, ['endDate', 'initialDate']);
                            filter.customFilter.groups = [this.props.row.code.toString()];
                            return (
                                <Query query={PUBLISHER_WEEKLY_EVOLUTION_BOOKSTORES} variables={filter} >
                                    {({ loading, error, data, client }) => {
                                        return this.renderBookstoreData(data, loading, error);
                                    }}
                                </Query>
                            );
                        }}
                    </Query> : null
                }
            </React.Fragment>
        );
    }

    private renderBookstoreData(data:any, loading:any, error: any) {
        if(this.state.open) {
            if(loading) {
                return (
                    <TableRow>
                        <TableCell colSpan={7}>
                            <LinearProgress />
                        </TableCell>
                    </TableRow>
                );
            } else if (error) {
                return (
                    <TableRow>
                        <TableCell colSpan={7} >
                            {'Falha ao consultar a evolução semanal, tente novamente.'}
                        </TableCell>
                    </TableRow>
                )
            } else {
                if(data && data.publisherWeeklyEvolutionBookstore && data.publisherWeeklyEvolutionBookstore.length > 0) {
                    return data.publisherWeeklyEvolutionBookstore.map( (bookstore: any, key:number) => {
                        return (
                            <TableRow key={'bookstore'+key}>
                                <TableCell />
                                <TableCell>{bookstore.name}</TableCell>
                                {
                                    this.props.weeks.map((week: number) => {
                                        return this.rendColumnsValuesForWeek (bookstore, week)
                                    })
                                }
                            </TableRow>
                        )
                    });
                } else {
                    return (
                        <TableRow>
                            <TableCell colSpan={7}>Nenhum dado para a loja</TableCell>
                        </TableRow>
                    )
                }
            }
        } else {
            return null;
        }
    }

    private rendColumnsValuesForWeek (row:any, week: number) {
        
        if(row.data && row.data.length > 0) {
            const weekData = row.data.filter((obj:any)=> {
                return obj.code === week;
            });
            if(weekData && weekData.length > 0) {
                return (
                    <TableCell>
                        <div>
                            { 
                                weekData[0].volume ? 
                                    NumberLessBRL(weekData[0].volume.toString()) :
                                    ' - ' 
                            } <br /> 
                            { 
                                weekData[0].volumeEvolution ? 
                                    weekData[0].volumeEvolution.toFixed(2).replace(/\./g, ',') + ' %' : 
                                    ' - '
                            }
                        </div>
                    </TableCell>
                );
            } else {
                return (<TableCell />);
            }
        } else {
            return (<TableCell />);
        }
        
    }

    private handleDetailOpen () {
        this.setState({ open: !this.state.open });
    };
}



// WEBPACK FOOTER //
// ./src/component/publisher/sale/weekly-evolution/PublisherWeeklyEvolutionRow.tsx